import { TextNodeType } from "@tm/ui-widgets/components";
import FormattedText from "../FormattedText/FormattedText";
import H4Tag from "../TextStyles/H4Tag";

type HeaderTitleCompProps = {
  title: TextNodeType;
};

const HeaderTitleComp = (data: HeaderTitleCompProps) => {
  return (
    <H4Tag>
      <FormattedText value={data.title} baseStyle={{ color: "white" }} />
    </H4Tag>
  );
};

export default HeaderTitleComp;
